/**
 * @generated SignedSource<<ec8976be60b6ecfcbf6f35373ed421ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutGuestBuyerQueryRenderer_buyer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryOptionsQueryRenderer_buyer" | "CheckoutMobilePageHeader_buyer" | "CheckoutPageHeader_buyer" | "useBuyerFetchHandler_buyer" | "useBuyerFetchHandler_fetchedBuyer">;
  readonly " $fragmentType": "CheckoutGuestBuyerQueryRenderer_buyer";
};
export type CheckoutGuestBuyerQueryRenderer_buyer$key = {
  readonly " $data"?: CheckoutGuestBuyerQueryRenderer_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutGuestBuyerQueryRenderer_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMobile"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutGuestBuyerQueryRenderer_buyer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryOptionsQueryRenderer_buyer"
    },
    {
      "condition": "isMobile",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CheckoutPageHeader_buyer"
        }
      ]
    },
    {
      "condition": "isMobile",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CheckoutMobilePageHeader_buyer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBuyerFetchHandler_buyer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useBuyerFetchHandler_fetchedBuyer"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "5b7716ea1e5af6206c174ffbfcb4ac95";

export default node;
